$(document).ready(function (e) {
  // 	if ($(document).find('#ClientReviewForm').length > 0){

  // 		var dom = $(document).find('#ClientReviewForm');

  // 		// when we select the portfolio mandated strategy (ie "Balanced","Conservative")
  // 		dom.on('change', '.field input[name="PortfolioMandatedStrategy"]', function(event){

  // 			var dateField = $(document).find('.field input[name="PortfolioMandatedStrategyDate"]');

  // 			if(
  // 				$(this).val() == 'DIMS Income' ||
  // 				$(this).val() == 'DIMS Conservative' ||
  // 				$(this).val() == 'DIMS Balanced' ||
  // 				$(this).val() == 'DIMS Growth' ||
  // 				$(this).val() == 'DIMS High Growth' ){
  // 					dateField.val( '01/06/2015' );
  // 				}else{
  // 					dateField.val( '' );
  // 				}
  // 		});
  // 	}
  // });
  // });

  //listen for changes of specific fields to set the jobsize & prevent navigation
  $("input[type=radio][name=PropertyTypeOptions]").on("input", function (e) {
    if ($(this).prop("checked")) {
      if (this.value == "Distributed Generation") {
        $("#Form_Form_JobSize").val("Large").trigger("input");
      }
    }
    canNavigateNext();
  });

  //Make one for UML to Medium
  $("input[type=radio][name=PropertyTypeOptions]").on("input", function (e) {
    if ($(this).prop("checked")) {
      if (this.value == "Unmetered Load") {
        $("#Form_Form_JobSize").val("Medium").trigger("input");
      }
    }
    canNavigateNext();
  });

  $("input[type=radio][name=NeedMoreThanSingle60Amp]").on(
    "input",
    function (e) {
      if ($(this).prop("checked")) {
        if (this.value == "Yes") {
          $("#Form_Form_JobSize").val("Medium").trigger("input");
        }
      }
    }
  );

  $("input[type=radio][name=SupplyFromBoundary]").on("input", function (e) {
    if ($(this).prop("checked")) {
      if (this.value == "OverHalfWithin20Metres") {
        $("#Form_Form_JobSize").val("Small").trigger("input");
      } else if (this.value == "DontKnowOver20Metres") {
        $("#Form_Form_JobSize").val("Medium").trigger("input");
      }
    }
    canNavigateNext();
  });

  $("input[name=NumberOfDwellings]").on("input", function (e) {
    if (this.value >= 4 && this.value <= 45) {
      $("#Form_Form_JobSize").val("Medium").trigger("input");
    } else if (this.value >= 46) {
      $("#Form_Form_JobSize").val("Large").trigger("input");
    }
  });

  $("input[type=radio][name=SupplyFromBoundary2]").on("input", function (e) {
    if ($(this).prop("checked")) {
      if (this.value == "OverHalfWithin20Metres") {
        $("#Form_Form_JobSize").val("Small").trigger("input");
      } else if (this.value == "DontKnowOver20Metres") {
        $("#Form_Form_JobSize").val("Medium").trigger("input");
      }
    }
    canNavigateNext();
  });

  $("input[name=HighVoltage]").on("input", function (e) {
    if ($(this).prop("checked")) {
      if (this.value == "Yes") {
        $("#Form_Form_JobSize").val("Large").trigger("input");
      }
    }
  });

  $("input[name=AnticipatedElectricalLoad]").on("input", function (e) {
    if ($(this).prop("checked")) {
      if (this.value == "Over 3ph 100A; up to 300A") {
        $("#Form_Form_JobSize").val("Medium").trigger("input");
      } else if (this.value == "Over 300A (200kVA)") {
        $("#Form_Form_JobSize").val("Large").trigger("input");
      }
    }
  });

  $("input[name=MoreThanOneNonResidentialPremises]").on("input", function (e) {
    if ($(this).prop("checked")) {
      if (this.value == "Yes") {
        $("#Form_Form_JobSize").val("Medium").trigger("input");
      }
    }
  });

  //listen for changes of specific fields to disabled next
  function canNavigateNext() {
    if (
      $("input[type=radio][name=SupplyFromBoundary]:checked").val() ==
        "WithinHalfMetre" ||
      $("input[type=radio][name=SupplyFromBoundary2]:checked").val() ==
        "WithinHalfMetre"
    ) {
      $(".step-controls .button.next").hide();
      $(".step-controls .button.prev").hide();
    } else {
      $(".step-controls .button.next").show();
      $(".step-controls .button.prev").show();
    }
  }
});
